import React, {ChangeEvent, Component, ReactNode} from 'react';
import {ValidatedFieldProps, ValidatedFieldState} from 'components/forms/validation';
import {Checkbox, FormControl, FormControlLabel, FormHelperText} from '@material-ui/core';

interface CheckBoxFieldProps extends ValidatedFieldProps {
  label?: ReactNode;
  name?: string;
  disabled?: boolean;
  onChange?: (value: boolean)=>void;
  className?: string;
  checked?: boolean;
}

interface CheckBoxFieldState extends ValidatedFieldState {
  value: boolean;
}

export default class CheckBoxField extends Component<CheckBoxFieldProps, CheckBoxFieldState> {
  public state: CheckBoxFieldState = {
      dirty: false,
      touched: false,
      validationMessage: undefined,
      value: false
  };

  componentDidMount(): void {
    if(this.props.validationGroup && this.props.name) {
      this.props.validationGroup.addFieldListener(this.props.name, this.onValidChanged);
    }
    if(this.props.checked !== undefined) {
      this.setState({'value': this.props.checked});
    } else if(this.props.model && this.props.name) {
      this.setState({'value': !!this.props.model[this.props.name]});
    }
  }

  componentWillUnmount(): void {
    if(this.props.validationGroup && this.props.name) {
      this.props.validationGroup.removeFieldListener(this.props.name, this.onValidChanged);
    }
  }

  componentDidUpdate(prevProps: Readonly<CheckBoxFieldProps>, prevState: Readonly<CheckBoxFieldState>, snapshot?: any): void {
    if(this.props.checked !== undefined && this.props.checked !== prevProps.checked) {
      this.setState({'value': this.props.checked});
    } else if(this.props.model && this.props.name && (this.props.model !== prevProps.model || this.props.name !== prevProps.name)) {
      this.setState({'value': !!this.props.model[this.props.name]});
    }
  }

  onValidChanged = (errors: string[], forceDirty: boolean) => {
    const touched = this.state.touched || forceDirty;
    const dirty = this.state.dirty || forceDirty;
    if(errors) {
      let msg = this.props.validationMessages ? this.props.validationMessages[errors[0]] : null;
      if(!msg) {
        msg = errors[0];
      }
      this.setState({ validationMessage: msg, dirty: dirty, touched: touched });
    } else {
      this.setState({ validationMessage: undefined, dirty: dirty, touched: touched });
    }
  };

  onChange = (ev: ChangeEvent<HTMLInputElement>) => {
    const value = ev.target.checked;
    this.setState({dirty: true, touched: true, value: value}, () => {
      if(this.props.model && this.props.name) {
        this.props.model[this.props.name] = value;
      }
      if(this.props.validationGroup && this.props.name) {
        this.props.validationGroup.validateField(this.props.name);
      }
      if(this.props.onChange) {
        this.props.onChange(value);
      }
    });
  };

  render() {
    const showError = this.state.touched && this.state.dirty && !!this.state.validationMessage;
    const fullClassName = this.props.className ? `checkbox-field ${this.props.className}` : 'checkbox-field';
    return <FormControl className={fullClassName} error={showError}>
      <FormControlLabel label={this.props.label} control={<Checkbox
        disabled={this.props.disabled}
        checked={this.state.value}
        onChange={this.onChange}
      />} />
      { showError && <FormHelperText>{ this.state.validationMessage }</FormHelperText> }
    </FormControl>;
  }
}